





































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TextField extends Vue {
  /**
   * A value passed via v-model directive
   */
  @Prop({ type: [String, Number] })
  private value!: string | number | undefined;

  /**
   * An input html type
   * @values text button checkbox color date datetime-local etc
   */
  @Prop({ type: String, default: "text" })
  private type!: string;

  @Prop({ type: Boolean, default: false })
  private readonly!: boolean;

  /**
   * Whether an input has a validation error
   */
  @Prop({ type: String, default: "" })
  private error!: string;
}
